import { Checkbox, Divider, Grid, Paper, TextField, Theme, Tooltip, Typography } from '@material-ui/core';
import React from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionTitle } from '../../components/SectionTitle';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps } from '../../types/types';
import { API_elaboraIForfetari } from '../../utils/functions';
import { useGlobal } from 'reactn';
import { IGlobalState } from '../../states/GlobalState';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         // formControl: {
//         //     margin: theme.spacing(1),
//         //     // minWidth: 320,
//         // },
//         // fullWidthPaper: {
//         //     padding: theme.spacing(2),
//         //     margin: theme.spacing(2),
//         //     width: "100%"
//         // },
//         // textField: {
//         //     marginLeft: theme.spacing(1),
//         //     marginRight: theme.spacing(1),
//         //     width: 200,
//         // },
//         // bottomLabel: {
//         //     marginTop: '0.5rem',
//         // },
//         // root: {
//         //     flexGrow: 1,
//         // },
//         // grid: {
//         //     maxHeight: "2.5rem",
//         //     margin: "0.5rem 0"
//         // }
//     }),
// );

export default function Confronto(props: DefaultInputProps) {
    const [global] = useGlobal<IGlobalState>();
    // const classes = useStyles();
    const gClasses = globalStyles();
    const { state } = props;
    const action = "changeConfronto";

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    };

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraIForfetari(props, global, name, checked, action, true);
    }

    const handleBlur = (e: any) => {
        API_elaboraIForfetari(props, global);
    }

    return (
        <div className={gClasses.root}>
            <Grid container >
                <Grid item xs={12} style={{ margin: "0px auto" }}>
                    <Paper className={gClasses.fullWidthPaper}>
                        <SectionTitle text="Imposte"></SectionTitle>
                        <Grid container>
                            <Grid item xs={4}>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="h5">Regime forfetario</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="h5">Regime normale</Typography>
                            </Grid>
                        </Grid>
                        <Divider></Divider>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={12}>
                                <Typography variant="h6" style={{ fontWeight: 800 }}>{state.nomeCognome}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Imposta sostitutiva</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.redditoContributiImposta.impostaSostitutiva}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                            {/* <Grid item xs={4}>
                                <NumberField
                                    value={state.regimeNormale.determinazioneDelValoreDellaProduzioneNetta_N89}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid> */}
                        </Grid>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Contributi</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.confronto.G6_contributi}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.irpefImprenditore.I29}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                        </Grid>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Irpef</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.imprenditoreProfessionista.redditi_M12}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.irpefImprenditore.M14}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                        </Grid>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Addizionale regionale</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.imprenditoreProfessionista.redditi_K16}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.irpefImprenditore.K18}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                        </Grid>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Addizionale comunale</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.imprenditoreProfessionista.redditi_M16}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.irpefImprenditore.M18}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                        </Grid>
                        {state.datiCollaboratore1.nomeCognome1 !== undefined && state.datiCollaboratore1.nomeCognome1 !== "" ?
                            (
                                <React.Fragment>
                                    <Divider></Divider>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ fontWeight: 800 }}>Collab n.1: {state.datiCollaboratore1.nomeCognome1}</Typography>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography style={{ marginTop: "1rem" }}>Contributi</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <NumberField
                                                value={state.collaboratore1.rivalsaContrIvs_H33}
                                                className={gClasses.textFieldReadOnly}
                                                readOnly={true} />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <NumberField
                                                value={state.irpefCollaboratore1.H35}
                                                className={gClasses.textFieldReadOnly}
                                                readOnly={true} />
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography style={{ marginTop: "1rem" }}>IRPEF</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <NumberField
                                                value={state.collaboratore1.irpefNetta_M40}
                                                className={gClasses.textFieldReadOnly}
                                                readOnly={true} />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <NumberField
                                                value={state.irpefCollaboratore1.M42}
                                                className={gClasses.textFieldReadOnly}
                                                readOnly={true} />
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography style={{ marginTop: "1rem" }}>Addizionale regionale</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <NumberField
                                                value={state.collaboratore1.regionale_K44}
                                                className={gClasses.textFieldReadOnly}
                                                readOnly={true} />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <NumberField
                                                value={state.irpefCollaboratore1.K46}
                                                className={gClasses.textFieldReadOnly}
                                                readOnly={true} />
                                        </Grid>
                                    </Grid>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography style={{ marginTop: "1rem" }}>Addizionale comunale</Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <NumberField
                                                value={state.collaboratore1.comunale_M44}
                                                className={gClasses.textFieldReadOnly}
                                                readOnly={true} />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <NumberField
                                                value={state.irpefCollaboratore1.M46}
                                                className={gClasses.textFieldReadOnly}
                                                readOnly={true} />
                                        </Grid>
                                    </Grid>
                                    <Divider></Divider>
                                </React.Fragment>) : <p></p>}
                        {state.datiCollaboratore2.nomeCognome2 !== undefined && state.datiCollaboratore2.nomeCognome2 !== "" ?
                            (<React.Fragment>
                                <Grid item xs={12}>
                                    <Typography variant="h6" style={{ fontWeight: 800 }}>Collab n.2: {state.datiCollaboratore2.nomeCognome2}</Typography>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography style={{ marginTop: "1rem" }}>Contributi</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <NumberField
                                            value={state.collaboratore2.rivalsaContrIvs_H60}
                                            className={gClasses.textFieldReadOnly}
                                            readOnly={true} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <NumberField
                                            value={state.irpefCollaboratore2.H62}
                                            className={gClasses.textFieldReadOnly}
                                            readOnly={true} />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography style={{ marginTop: "1rem" }}>IRPEF</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <NumberField
                                            value={state.collaboratore2.irpefNetta_M67}
                                            className={gClasses.textFieldReadOnly}
                                            readOnly={true} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <NumberField
                                            value={state.irpefCollaboratore2.M69}
                                            className={gClasses.textFieldReadOnly}
                                            readOnly={true} />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography style={{ marginTop: "1rem" }}>Addizionale regionale</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <NumberField
                                            value={state.collaboratore2.regionale_K71}
                                            className={gClasses.textFieldReadOnly}
                                            readOnly={true} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <NumberField
                                            value={state.irpefCollaboratore2.K73}
                                            className={gClasses.textFieldReadOnly}
                                            readOnly={true} />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography style={{ marginTop: "1rem" }}>Addizionale comunale</Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <NumberField
                                            value={state.collaboratore2.comunale_M71}
                                            className={gClasses.textFieldReadOnly}
                                            readOnly={true} />
                                    </Grid>
                                    <Grid item xs={4}>
                                        <NumberField
                                            value={state.irpefCollaboratore2.M73}
                                            className={gClasses.textFieldReadOnly}
                                            readOnly={true} />
                                    </Grid>
                                </Grid>
                            </React.Fragment>) : <p></p>}
                        <Divider></Divider>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Totale</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.confronto.G25_totale}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.confronto.M25_totale}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                        </Grid>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={12}>
                                <Typography className={gClasses.bottomLabel}>Di cui:</Typography>
                            </Grid>
                        </Grid>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Imposte</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.confronto.D27_imposte}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.confronto.K27_imposte}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                        </Grid>
                        <Grid container className={gClasses.grid}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Contributi</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.confronto.D28_contributi}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                            <Grid item xs={4}>
                                <NumberField
                                    value={state.confronto.K28_contributi}
                                    className={gClasses.textFieldReadOnly}
                                    readOnly={true} />
                            </Grid>
                        </Grid>
                        <Grid container >
                            <Grid item xs={12}>
                                <Typography variant="subtitle2">ATTENZIONE - nell'anno del passaggio dal regime normale al regime forfetario, è necessario effettuare la rettifica a sfavore dell'Iva già detratta sull'acquisto di taluni beni e servizi.</Typography>
                            </Grid>
                            {/* <Grid item xs={12}>
                                <Typography variant="subtitle2">Nell'anno del passaggio dal regime forfetario al regime normale è ammessa la rettifica a favore dell'Iva non detratta sull'acquisto di taluni beni e servizi.</Typography>
                            </Grid> */}
                        </Grid>
                        <Grid container style={{marginTop: "20px"}}>
                            <Grid item xs={6}>
                                <Typography className={gClasses.bottomLabel}>Per il contribuente in esame la rettifica è pari a</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <NumberField
                                    name="G33"
                                    label=""
                                    value={state.confronto.G33}
                                    className={gClasses.textField}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                        <Grid container >
                            <Grid item xs={6}>
                                <Typography className={gClasses.bottomLabel}>Si stima che annualmente, l'Iva su acquisti correnti non ammessa in detrazione sia pari a</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <NumberField
                                    name="D36"
                                    label=""
                                    value={state.confronto.D36}
                                    className={gClasses.textField}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                        <Grid container >
                            <Grid item xs={12}>
                                <Typography variant="subtitle2">Particolare attenzione deve essere posta alla previsione di effettuare acquisti di beni strumentali. Si osserva che le imprese che hanno una clientela privata (es. commercianti al minuto), lasciano inalterati i corrispettivi per la cessione di beni e servizi, trattenendo così l'Iva idealmente compresa nei corrispettivi stessi.</Typography>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            <Grid container >
                <Grid item xs={12} style={{ margin: "0px auto" }}>
                    <Paper className={gClasses.fullWidthPaper}>
                        <SectionTitle text="Altre caratteristiche"></SectionTitle>
                        <Grid container>
                            <Grid item xs={4}>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="h5">Regime forfetario</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="h5">Regime normale</Typography>
                            </Grid>
                        </Grid>
                        <Divider></Divider>
                        <Grid container style={{ marginTop: "1rem" }}>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Applicazione dell'Iva</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled />
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Detrazione dell'Iva sugli acquisti</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled />
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Certificazione e trasmissione telematica dei corrispettivi</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />
                            </Grid>
                        </Grid>
                        {/* <Grid container>
                            <Grid item xs={4}>
                                <Tooltip title="Nel caso di autonoma organizzazione">
                                    <Typography className={gClasses.bottomLabel}>Irap *</Typography>
                                </Tooltip>
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled />
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />
                            </Grid>
                        </Grid> */}
                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>I.S.A. (ex studi di settore)</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled />
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Ritenuta d'acconto su compensi percepiti</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled />
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Tooltip title="Sì su retribuzioni dipendenti">
                                <Grid item xs={4}>
                                    <Typography className={gClasses.bottomLabel}>Ritenuta d'acconto su compensi corrisposti *</Typography>
                                </Grid>
                            </Tooltip>
                            <Tooltip title="Sì su retribuzioni dipendenti">
                                <Grid item xs={4}>
                                    <Checkbox disabled />
                                </Grid>
                            </Tooltip>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={4}>
                                <Typography className={gClasses.bottomLabel}>Contributi previdenziali</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />riduzione del 35% (opt)
                            </Grid>
                            <Grid item xs={4}>
                                <Checkbox disabled defaultChecked />nessuna riduzione
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={6}>
                            </Grid>
                            <Grid item xs={6}>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">In presenza della condizione per accedere al regime forfetario, l'adesione al regime di contabilità semplificata non comporta alcun vincolo temporale. L'opzione per il regime di contabilità ordinaria, al contrario, vincola per tre anni.</Typography>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} style={{ margin: "0px auto" }}>
                    <Paper className={gClasses.fullWidthPaper}>
                        <SectionTitle text="Adempimenti e relative spese amministrative (indicative)"></SectionTitle>
                        <Grid container>
                            <Grid item xs={6}>
                                <SectionTitle primary={true} text="Regime forfetario"></SectionTitle>
                                <Grid container>
                                    <Grid item xs={4} md={4}>
                                        <Typography variant="h6">Adempimento</Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2}>
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <Typography variant="h6">Spese</Typography>
                                    </Grid>
                                </Grid>
                                <Divider></Divider>
                                <Grid container  >
                                    <Grid item xs={4} md={4}>
                                        <Typography className={gClasses.bottomLabel}>Tenuta della contabilità</Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2}>
                                        <Checkbox  disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <NumberField
                                            name="G66"
                                            label=""
                                            value={state.confronto.G66}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container >
                                    <Grid item xs={4} md={4}>
                                        <Typography className={gClasses.bottomLabel}>Dichiarazione dei redditi</Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2}>
                                        <Checkbox  disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <NumberField
                                            name="G67"
                                            label=""
                                            value={state.confronto.G67}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                {/* <Grid container  >
                                    <Grid item xs={4} md={4}>
                                        <Typography className={gClasses.bottomLabel}>Dichiarazione Irap</Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2}>
                                        <Checkbox disabled />
                                    </Grid>
                                    <Grid item xs={6} md={3}>
                                        <NumberField
                                            name=""
                                            label=""
                                            value={""}
                                            className={gClasses.textFieldConfrontoReadOnly}
                                            readOnly={true}
                                        />
                                    </Grid>
                                </Grid> */}
                                <Grid container>
                                    <Grid item xs={4} lg={4}>
                                        <Typography className={gClasses.bottomLabel}>Versamenti Modd. F24</Typography>
                                    </Grid>
                                    <Grid item xs={2} lg={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G69"
                                            label=""
                                            value={state.confronto.G69}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4} >
                                        <Typography className={gClasses.bottomLabel}>Fatturazione elettronica</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name=""
                                            label=""
                                            value={""}
                                            className={gClasses.textFieldConfrontoReadOnly}
                                            readOnly={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel}>Liquidazioni e versamenti Iva</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name=""
                                            label=""
                                            value={""}
                                            className={gClasses.textFieldConfrontoReadOnly}
                                            readOnly={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel}>Dichiarazione annuale Iva</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name=""
                                            label=""
                                            value={""}
                                            className={gClasses.textFieldConfrontoReadOnly}
                                            readOnly={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel}>Altri adempimenti Iva</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox  disabled />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name=""
                                            label=""
                                            value={""}
                                            className={gClasses.textFieldConfrontoReadOnly}
                                            readOnly={true}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel}>Cedolini paghe</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox  disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G74"
                                            label=""
                                            value={state.confronto.G74}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel}>Denunce mensili retribuzioni</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox  disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G75"
                                            label=""
                                            value={state.confronto.G75}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel}>Altri adempimenti lavoro</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox  disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G76"
                                            label=""
                                            value={state.confronto.G76}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Tooltip title="Sì per retribuzioni dipendenti">
                                        <Grid item xs={4}>
                                            <Typography className={gClasses.bottomLabel}>Modelli CU *</Typography>
                                        </Grid>
                                    </Tooltip>
                                    <Tooltip title="Sì per retribuzioni dipendenti">
                                        <Grid item xs={2}>
                                            <Checkbox  disabled /> *
                                        </Grid>
                                    </Tooltip>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G77"
                                            label=""
                                            value={state.confronto.G77}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Tooltip title="Sì per retribuzioni dipendenti">
                                        <Grid item xs={4}>
                                            <Typography className={gClasses.bottomLabel}>Modello 770 *</Typography>
                                        </Grid>
                                    </Tooltip>
                                    <Tooltip title="Sì per retribuzioni dipendenti">
                                        <Grid item xs={2}>
                                            <Checkbox disabled /> *
                                    </Grid>
                                    </Tooltip>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G78"
                                            label=""
                                            value={state.confronto.G78}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="B79"
                                            label=""
                                            value={state.confronto.B79}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox 
                                            value={state.confronto.E79}
                                            name='E79'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G79"
                                            label=""
                                            value={state.confronto.G79}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="B80"
                                            label=""
                                            value={state.confronto.B80}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox 
                                            value={state.confronto.E80}
                                            name='E80'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G80"
                                            label=""
                                            value={state.confronto.G80}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="B81"
                                            label=""
                                            value={state.confronto.B81}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox 
                                            value={state.confronto.E81}
                                            name='E81'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G81"
                                            label=""
                                            value={state.confronto.G81}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="B82"
                                            label=""
                                            value={state.confronto.B82}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox 
                                            value={state.confronto.E82}
                                            name='E82'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G82"
                                            label=""
                                            value={state.confronto.G82}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="B83"
                                            label=""
                                            value={state.confronto.B83}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox 
                                            value={state.confronto.E83}
                                            name='E83'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G83"
                                            label=""
                                            value={state.confronto.G83}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="B84"
                                            label=""
                                            value={state.confronto.B84}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox 
                                            value={state.confronto.E84}
                                            name='E84'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G84"
                                            label=""
                                            value={state.confronto.G84}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="G86"
                                            label="Totale"
                                            value={state.confronto.G86}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={6}>
                                <SectionTitle primary={true} text="Regime normale"></SectionTitle>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography variant="h6">Adempimento</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <Typography variant="h6">Spese</Typography>
                                    </Grid>
                                </Grid>
                                <Divider></Divider>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Tenuta della contabilità</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M66"
                                            label=""
                                            value={state.confronto.M66}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Dichiarazione dei redditi</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M67"
                                            label=""
                                            value={state.confronto.M67}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Tooltip title="Nel caso di autonoma organizzazione" >
                                            <Typography className={gClasses.bottomLabel}>Dichiarazione Irap *</Typography>
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Tooltip title="Nel caso di autonoma organizzazione" >
                                            <Checkbox disabled defaultChecked />
                                        </Tooltip>
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M68"
                                            label=""
                                            value={state.confronto.M68}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Versamenti Modd. F24</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M69"
                                            label=""
                                            value={state.confronto.M69}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Fatturazione elettronica</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M70"
                                            label=""
                                            value={state.confronto.M70}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Liquidazioni e versamenti Iva</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M71"
                                            label=""
                                            value={state.confronto.M71}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Dichiarazione annuale Iva</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M72"
                                            label=""
                                            value={state.confronto.M72}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Altri adempimenti Iva</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M73"
                                            label=""
                                            value={state.confronto.M73}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Cedolini paghe</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M74"
                                            label=""
                                            value={state.confronto.M74}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Denunce mensili retribuzioni</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox  disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M75"
                                            label=""
                                            value={state.confronto.M75}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel}>Altri adempimenti lavoro</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M76"
                                            label=""
                                            value={state.confronto.M76}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Modelli CU</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M77"
                                            label=""
                                            value={state.confronto.M77}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Typography className={gClasses.bottomLabel} >Modello 770</Typography>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox disabled defaultChecked />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M78"
                                            label=""
                                            value={state.confronto.M78}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                {/* <Grid container>
                                    <Grid item xs={3}>
                                        <Typography className={gClasses.bottomLabel}></Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                    </Grid>
                                    <Grid item xs={3}>
                                    </Grid>
                                </Grid> */}

                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="I79"
                                            label=""
                                            value={state.confronto.I79}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox                                            
                                            value={state.confronto.L79}
                                            name='L79'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M79"
                                            label=""
                                            value={state.confronto.M79}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="I80"
                                            label=""
                                            value={state.confronto.I80}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox                                            
                                            value={state.confronto.L80}
                                            name='L80'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M80"
                                            label=""
                                            value={state.confronto.M80}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="I81"
                                            label=""
                                            value={state.confronto.I81}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox                                            
                                            value={state.confronto.L81}
                                            name='L81'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M81"
                                            label=""
                                            value={state.confronto.M81}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="I82"
                                            label=""
                                            value={state.confronto.I82}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox                                            
                                            value={state.confronto.L82}
                                            name='L82'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M82"
                                            label=""
                                            value={state.confronto.M82}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="I83"
                                            label=""
                                            value={state.confronto.I83}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox                                            
                                            value={state.confronto.L83}
                                            name='L83'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M83"
                                            label=""
                                            value={state.confronto.M83}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <TextField
                                            id=""
                                            name="I84"
                                            label=""
                                            value={state.confronto.I84}
                                            onChange={handleChange} onBlur={handleBlur}
                                            className={gClasses.textFieldConfronto}
                                            InputLabelProps={{ shrink: true }}
                                            margin="dense"
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Checkbox                                            
                                            value={state.confronto.L84}
                                            name='L84'
                                            id=''
                                            onChange={handleChangeChecked}
                                            inputProps={{ 'aria-label': 'primary checkbox' }} />
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M84"
                                            label=""
                                            value={state.confronto.M84}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid item xs={2}>
                                    </Grid>
                                    <Grid item xs={6} lg={3}>
                                        <NumberField
                                            name="M86"
                                            label="Totale"
                                            value={state.confronto.M86}
                                            className={gClasses.textFieldConfronto}
                                            onChange={handleChange} onBlur={handleBlur}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>
        </div >
    );
}